import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './RowHeader.scss';

const RowHeader = (props) => {
  const { opts = {} } = props;
  const {
    id,
    heading,
    cta,
    ctaLink,
    subHeading
  } = opts;
  return (
    <>
      <div className="row-header" id={id}>
        <div className="row-header__title">
          <span className="row-header__text">{heading}</span>
          {cta
            && <a className="row-header__link" href={ctaLink}>{cta}</a>}
        </div>
      </div>
      <div className="page-subheader">{subHeading}</div>
    </>
  );
};

RowHeader.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    ctaLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    cta: PropTypes.string,
  }).isRequired
};
RowHeader.defaultProps = {
};

export default RowHeader;
